import { render } from "./CustomerCreateTicket.vue?vue&type=template&id=2c98870e&scoped=true"
import script from "./CustomerCreateTicket.vue?vue&type=script&lang=js"
export * from "./CustomerCreateTicket.vue?vue&type=script&lang=js"

import "./CustomerCreateTicket.vue?vue&type=style&index=0&id=2c98870e&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c98870e"]])

export default __exports__